<div class="trip-details-wrapper">
  <app-loader *ngIf="isLoading; else elseTemplate"></app-loader>
  <ng-template #elseTemplate>
    <form [formGroup]="formDetails">
      <div class="trip-header-container">
        <div class="trip-form-wrapper">
          <ng-container *ngFor="let field of tripDetailsConfig">
            <ng-container [ngSwitch]="field.elementKey">
              <ng-container *ngSwitchCase="'Date Toggle'">
                <ng-container *ngIf="formDetails.get('tripDetails').get('DateSelection').value.length > 1">
                  <!-- <div class="form-control">
                    <label class="form-label">{{field.config.displayName}}</label>
                    <app-field-generator [config]="field.config"
                      [inputControl]="formDetails.get('tripDetails').get(field.elementKey)"></app-field-generator>
                  </div> -->
                </ng-container>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div class="form-control date-picker-section" >
                  <!-- <label class="form-label">{{field.config.displayName}}</label> -->
                  <div class="date-selector">
                    <span class="booking-date-label mr-16 fs-12 position-relative">Date</span>
                    <app-mis-datepicker class="trip-mis-date" [singleDateEnabled]="false"
                     [inputControl]="formDetails.get('tripDetails').get(field.elementKey)"
                     [enableBackDatedBooking]="enableBackDatedBooking" [referenceBooking]="referenceBooking"  [enableDateRangePicker]="false"
                     ></app-mis-datepicker>
                  </div>
                  <div class="date-selector" *ngIf="formDetails.get('tripDetails').get(field.elementKey).value.length>1">
                    <span class="booking-date-label selected-date-label fs-12 position-relative">Selected Dates</span>
                  </div>
                   <div class="date-container" *ngIf="formDetails.get('tripDetails').get(field.elementKey).value.length>1">
                    <span>{{formDetails.get('tripDetails').get(field.elementKey).value[0][0]._i}}</span>
                    <div class="chip" (mouseenter)="showDates=true" (mouseleave)="showDates=false">{{formDetails.get('tripDetails').get(field.elementKey).value.length-1}}</div>
                    <ng-template [ngIf]="showDates">
                      <div class="datelist displayFlexColumn">
                        <div class="displayFlex" *ngFor="let dates of formDetails.get('tripDetails').get(field.elementKey).value.slice(1)">
                          <span class="mr-4 ml-4">{{dates[0]._i}}</span>
                          <!-- <span *ngIf="rider.department"> ({{rider.department}})</span> -->
                        </div>
                      </div>
                    </ng-template>
                   </div>
                   <div class="backdated-div" >
                    <span class="mr-16 ml-16 ">
                      <img src="assets/dateLineSeparator.svg" alt="">
                    </span>
                    <div class="backdated-toggle ">
                      <span class="mr-16 fs-12" [ngStyle]="disableOnEdit ? {'color': '#929DAB'}:{'color': '#000'}">Backdated Booking</span>
                        <mis-switch  (valueChanged)="onBackDateToggle($event)" [checked]="enableBackDatedBooking"  [ngClass]="{'disableDropdown':disableOnEdit }"></mis-switch>
                    </div>
                   </div>
                   <div class="billing-type-container displayFlex align-item-center" *ngIf="miscellConfig?.verifyEngagementCode">
                      <span class="mr-16 ml-16 ">
                        <img src="assets/dateLineSeparator.svg" alt="">
                      </span>
                      <span class="fs-12 color-000">Recoverable Type</span>
                      <span style="color: #B00020;" class="mr-8">*</span>
                      <mis-dropdown 
                      [ngClass]="{disableDropdown: checkDropdownDisable()}"
                      [data]="billableTypes" 
                      [searchEnabled]="false" 
                      [selectedItem]="{label: formDetails.get('billableType')?.value, value: formDetails.get('billableType')?.value}"
                      [label]="formDetails.get('billableType')?.value || 'Select'" 
                      height="38px" width="150px"
                      dropdownListHeight="80px" 
                      dropdownListPosition="Left" 
                      noDataMessage="No Data"
                      (onChange)="handleBillableTypeChange($event)"
                      >
                      </mis-dropdown> 
                   </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
        
        <div class="upload-rate"> 
          <span *ngIf="miscellConfig['enableRiderUploadDocuments'] && getFormControl('dateWise').controls.length == 1" class="link" (click)="fileInput.click()">Upload Document</span>
          <input #fileInput type="file" (change)="onFileInput($event)" style="display:none;" />
          <div *ngIf="viewRateCardElement.config.visibility.visible" class="rate-card-link">
            <span class="link" (click)="showRateCard()">{{viewRateCardElement.config.displayName}}</span>
          </div>
        </div>
      
      </div>

<!-- --------------new  -->

<div *ngIf="uploadedDocumentList.length>0" class="mb-16">
  <div class="mb-12 font-weight-400 fs-16 color-000">Uploaded Documents</div>
  <div class="displayFlexRow mb-16">
   <div *ngFor="let image of uploadedDocumentList; let i = index" >
      <div class="doc-items displayFlexSpaceBetween" [ngStyle]="i==uploadedDocumentList.length-1 ?  {'margin-right':'0'} :{'margin-right':'16px'}">
        <div class="displayContents" (click)="createBookingService.isEditMode? myBookingService.downloadDocument(image.filename,editBookingId) :  onDocClicked(i)">
          <div class="displayContents">
           <img src="assets/upload_document.svg" alt="">
          </div>
 
          <div class="file-details">
           <span matTooltip="{{image.filename}}" matTooltipClass="doc-upload-tooltip">{{image.filename}}</span>
          
           <span *ngIf="createBookingService.isEditMode; else newBooking">{{myBookingService.convertToMB(image.filesize)}} MB</span>
           <ng-template #newBooking>
            <span>{{image.filesize}} MB</span>
           </ng-template>
          </div>
        </div>

        <div class="remove-file">
          <span ><img src="assets/close.svg" (click)="deleteDoc(image)"></span>
        </div>
      </div>

      
       <!-- ------delete doc -->
       <app-dialog *ngIf="deleteDocPopup" titleText="Warning" type="confirm" [buttonText]="['Yes', 'No']"
       (approveCallback)="createBookingService.isEditMode? removeExistingDoc(deleteDocName):removeFile(deleteDocName)" (dismissCallback)="deleteDocPopup=false"
       (closeCallback)="deleteDocPopup=false" icon="true" src="assets/ic-ui-warning-24.svg">
       Are you sure you want to delete <b>  {{deleteDocName}}</b> ?
       </app-dialog>
    </div>
   <div class="saveDocButton">
    <button (click)="saveDocuments()">Save</button>
  </div>
  </div>
  
  <ng-template [ngIf]="showSuccessToast">
    <div class=" doc-snackbar">
        <span><img src="assets/successWhite.svg" alt="success"></span>
        {{toastMsg}}
    </div>
</ng-template>
</div>

     <div class="">
      <app-date-wise-booking-form *ngFor="let dateForm of getFormControl('dateWise').controls;  let index = index"
      [dates]="formDetails.get('tripDetails').get('DateSelection').value" [formDetails]="dateForm"
      [bookingEditConfig]="bookingEditConfig" [bookingCreationDisabledDays]="bookingCreationCutoff.disabledForWeeks"
      [config]="dateWiseConfig" [cabConfig]="cabConfig" [index]="index" [userDetails]="userDetails"
      [dateEditable]="getFormControl('dateWise').controls.length > 1" (dateChangeCallback)="onDateChangeInCard()"
      (deleteCallback)="deleteDateCard($event)" [referenceBooking]="referenceBooking" (applySameDetails)="showDateMergeWarning()"  [bookingFormLength]="getFormControl('dateWise').controls.length"
      [miscellConfig]="miscellConfig"   [workflowConfig]="workflowConfig" [configComplete]="configComplete" [designationConfig]="designationConfig">
    </app-date-wise-booking-form>
     </div>
      
    </form>
    <app-dialog *ngIf="isDateRemoveWarning" titleText="Confirm" type="confirm" [buttonText]="['Yes', 'No']"
      (approveCallback)="onDateChangeApprove()" (dismissCallback)="onDateChangeCancel()">
      You will lose any data you have entered for the dates removed. Do you wish to continue?
    </app-dialog>
    <app-dialog *ngIf="isDateMergeWarning" titleText="Confirm" type="confirm" [buttonText]="['Yes', 'No']"
      (approveCallback)="applySameData()" (dismissCallback)="onDateMergeCancel()">
      The details entered for first date will be applied to all. Do you wish to continue?
    </app-dialog>
  </ng-template>
  <app-dialog
  *ngIf="uploadDocumentsExceeded"
  titleText="File Upload Exceeded"
  type="alert"
  [buttonText]="['Okay']"
  (approveCallback)="uploadDocumentsExceeded = false"
  icon="true" src="assets/ic-ui-warning-24.svg"
>
  You cannot Upload more than 5 Files.
</app-dialog>
<app-dialog
  *ngIf="fileSizeExceeded"
  titleText="File Size Exceeded"
  type="alert"
  [buttonText]="['Okay']"
  (approveCallback)="fileSizeExceeded = false"
  icon="true" src="assets/ic-ui-warning-24.svg"
>
  File Size cannot be more than 5MB.
</app-dialog>
  <app-popover *ngIf="showImage" class="view-invoice-form" (closeCallback)="closePopOver()"
    size="creatBooking-ratecard">
    <div popover-header class="rate-card-header">
      Rate Card
    </div>
    <div popover-content >
      <!-- <div style="height: 300px; width: 508px;" *ngIf="!rateCardImageURL"></div> -->
      <app-loader *ngIf="imageLoading"></app-loader>
      <div *ngIf="rateCardImageURL">
        <img [src]="getSafeUrl()" />
      </div>
      <div *ngIf="errorInGettingImage" class="error">
        <div >
          <img src="../../../../assets/images/no-ratecard.svg" alt="">
        </div>
        <div >
          No document is available. Please check with your transport team.
        </div>
      </div>
    </div>
  </app-popover>
</div>